import * as _ from 'underscore';
import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { IDataRoleInfo } from '../models/IDataRoleInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataRoles } from '../resources/Dataroles';
import { IResult } from '../ServerApi/types/IResponse';
import { IUserName } from '../ServerApi/types/IUser';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { IConfirmChangeOwnerScope } from './ContentActions';
import { DataRoleErrors } from './DataRoleErrors';
import { ModalService } from './ModalService';
import { SearchSuggestionsService } from './SearchSuggestionsService';

export class ChangeDataRoleOwnerAction {

  public static $inject = ['DataRoleErrors', 'ActionHelpers', 'ConfirmActionDialog', '$translate', 'DataRoles', 'SearchSuggestionsService', 'ModalService'];

  constructor(
    private DataSourceErrors: DataRoleErrors,
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private DataRoles: DataRoles,
    private suggestions: SearchSuggestionsService,
    private ModalService: ModalService) { }

  public confirmChangeOwner(dataRoles: Set<IDataRoleInfo>, context: IActionContext): ng.IPromise<IResult> {

    const ownerPicker = {
      prompt: dataRoles.size() === 1
      ? this.$translate.instant('changeOwnerDataRolePrompt', { NAME: L10n.elideIfLong(dataRoles.first().name) })
      : this.$translate.instant('changeOwnerDataRolesPrompt', { COUNT: dataRoles.size() }, L10n.Interpolations.Count),
      ownerQuery: (matchText: string) => this.suggestions.usersWithoutGuest(matchText),
      targetOwner: <IUserName>null
    };
    const newDialogScope = <IConfirmChangeOwnerScope> context.scope.$new();
    newDialogScope.ownerPicker = ownerPicker;

    let currentOwnerId = dataRoles.first().owner.id;
    if(_.any(dataRoles.toArray(), (ds: IDataRoleInfo) => (ds.owner.id !== currentOwnerId))) {
      currentOwnerId = null;
    }

    return this.ConfirmActionDialog.open({
      scope: newDialogScope,
      title: this.$translate.instant('changeOwner'),
      bodyTemplateUrl: 'changeOwnerDialog.html',
      actionName: this.$translate.instant('changeOwnerConfirm', { COUNT: dataRoles.size() }, L10n.Interpolations.Count),

      action: (dialogInstance: IConfirmActionDialogInstance) => {
        return this.DataRoles.setOwner(dataRoles.keys(), ownerPicker.targetOwner.id)
          .then((result: IResult) => this.notifyResult(dataRoles, result, ownerPicker.targetOwner.displayName));
      },
      confirmDisabled: () => !ownerPicker.targetOwner || ownerPicker.targetOwner.id === currentOwnerId
    }).result.finally(() => newDialogScope.$destroy());
  }

  private notifyResult(dataRoles: Set<IDataRoleInfo>, result: IResult, ownerName: string) {
    this.ActionHelpers.notifyStandardError(
        dataRoles,
      {
        successId: 'changeOwnerDataRolesSuccess',
        errorId: 'changeOwnerDataRolesError'
      },
      (errorItem: IErrorItem<IDataRoleInfo>) => this.DataSourceErrors.errorDetailsFor(errorItem),
      { OWNER_NAME: ownerName }
    )(result);
  }

}

Module.instance().service('ChangeDataRoleOwnerAction', ChangeDataRoleOwnerAction);
